import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  SEARCH_TILE: {
    GET_DASHBOARD_CONTENT: (skip, query) => ({ skip, query }),
    API: {
      GET_DASHBOARD_CONTENT: apiResourceActionCreator('dashboardContent')
    }
  }
})

export const apiAction = (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/dashboard-content${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.searchTile.api.getDashboardContent)

export function* getDashboardContent(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.skip, action.payload && action.payload.query));
}

const configuration = {
  name: 'getDashboardContent',
  action: actions,
  sagas: getDashboardContent,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        isFetching: true
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        dashboardContent: action.payload.dashboardContent,
        error: null
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/configurations/getDashboardContent.js